module.exports = __webpack_public_path__ + "static/img/产品界面图_04@2x.60406514.png";